const LanguageListFR = {
  aa: 'afar',
  ab: 'abkhaze',
  ae: 'avestique',
  af: 'africain',
  ak: 'akan',
  am: 'amharique',
  an: 'aragonais',
  ar: 'arabe',
  as: 'assamais',
  av: 'avar',
  ay: 'aymara',
  az: 'azéri',
  ba: 'bachkir',
  be: 'biélorusse',
  bg: 'bulgare',
  bh: 'langues biharis',
  bi: 'bichlamar',
  bm: 'bambara',
  bn: 'bengali',
  bo: 'tibétain',
  br: 'breton',
  bs: 'bosniaque',
  ca: 'catalan; valencien',
  ce: 'tchétchène',
  ch: 'chamorro',
  co: 'corse',
  cr: 'cree',
  cs: 'tchèque',
  cu: "slavon d'église; vieux slave; slavon liturgique; vieux bulgare",
  cv: 'tchouvache',
  cy: 'gallois',
  da: 'danois',
  de: 'allemand',
  dv: 'maldivien',
  dz: 'dzongkha',
  ee: 'éwé',
  el: 'grec moderne (après 1453)',
  en: 'anglais',
  eo: 'espéranto',
  es: 'espagnol; castillan',
  et: 'estonien',
  eu: 'basque',
  fa: 'persan',
  ff: 'peul',
  fi: 'finnois',
  fj: 'fidjien',
  fo: 'féroïen',
  fr: 'français',
  fy: 'frison occidental',
  ga: 'irlandais',
  gd: 'gaélique; gaélique écossais',
  gl: 'galicien',
  gn: 'guarani',
  gu: 'goudjrati',
  gv: 'manx; mannois',
  ha: 'haoussa',
  he: 'hébreu',
  hi: 'hindi',
  ho: 'hiri motu',
  hr: 'croate',
  ht: 'haïtien; créole haïtien',
  hu: 'hongrois',
  hy: 'arménien',
  hz: 'herero',
  ia: 'interlingua (langue auxiliaire internationale)',
  id: 'indonésien',
  ie: 'interlingue',
  ig: 'igbo',
  ii: 'yi de Sichuan',
  ik: 'inupiaq',
  io: 'ido',
  is: 'islandais',
  it: 'italien',
  iu: 'inuktitut',
  ja: 'japonais',
  jv: 'javanais',
  ka: 'géorgien',
  kg: 'kongo',
  ki: 'kikuyu',
  kj: 'kuanyama; kwanyama',
  kk: 'kazakh',
  kl: 'groenlandais',
  km: 'khmer central',
  kn: 'kannada',
  ko: 'coréen',
  kr: 'kanouri',
  ks: 'kashmiri',
  ku: 'kurde',
  kv: 'kom',
  kw: 'cornique',
  ky: 'kirghiz',
  la: 'latin',
  lb: 'luxembourgeois',
  lg: 'ganda',
  li: 'limbourgeois',
  ln: 'lingala',
  lo: 'lao',
  lt: 'lituanien',
  lu: 'luba-katanga',
  lv: 'letton',
  mg: 'malgache',
  mh: 'marshall',
  mi: 'maori',
  mk: 'macédonien',
  ml: 'malayalam',
  mn: 'mongol',
  mo: 'moldovan',
  mr: 'marathe',
  ms: 'malais',
  mt: 'maltais',
  my: 'birman',
  na: 'nauruan',
  nb: 'norvégien bokmål',
  nd: 'ndébélé du Nord',
  ne: 'népalais',
  ng: 'ndonga',
  nl: 'néerlandais; flamand',
  nn: 'norvégien nynorsk; nynorsk, norvégien',
  no: 'norvégien',
  nr: 'ndébélé du Sud',
  nv: 'navaho',
  ny: 'chichewa; chewa; nyanja',
  oc: 'occitan (après 1500)',
  oj: 'ojibwa',
  om: 'galla',
  or: 'oriya',
  os: 'ossète',
  pa: 'pendjabi',
  pi: 'pali',
  pl: 'polonais',
  ps: 'pachto',
  pt: 'portugais',
  qu: 'quechua',
  rm: 'romanche',
  rn: 'rundi',
  ro: 'roumain; moldave',
  ru: 'russe',
  rw: 'rwanda',
  sa: 'sanskrit',
  sc: 'sarde',
  sd: 'sindhi',
  se: 'sami du Nord',
  sg: 'sango',
  sh: 'serbo-croate',
  si: 'singhalais',
  sk: 'slovaque',
  sl: 'slovène',
  sm: 'samoan',
  sn: 'shona',
  so: 'somali',
  sq: 'albanais',
  sr: 'serbe',
  ss: 'swati',
  st: 'sotho du Sud',
  su: 'soundanais',
  sv: 'suédois',
  sw: 'swahili',
  ta: 'tamoul',
  te: 'télougou',
  tg: 'tadjik',
  th: 'thaï',
  ti: 'tigrigna',
  tk: 'turkmène',
  tl: 'tagalog',
  tn: 'tswana',
  to: 'tongan (Îles Tonga)',
  tr: 'turc',
  ts: 'tsonga',
  tt: 'tatar',
  tw: 'twi',
  ty: 'tahitien',
  ug: 'ouïgour',
  uk: 'ukrainien',
  ur: 'ourdou',
  uz: 'ouszbek',
  ve: 'venda',
  vi: 'vietnamien',
  vo: 'volapük',
  wa: 'wallon',
  wo: 'wolof',
  xh: 'xhosa',
  yi: 'yiddish',
  yo: 'yoruba',
  za: 'zhuang; chuang',
  zh: 'chinois',
  zu: 'zoulou',

  /**
   * Extended List
   */
  'en-GB': 'Anglais (Royaume-Uni)',
  'es-MX': 'Espagnol (Mexique)',
  'pt-BR': 'Portugais Brésilien',
  'zh-TW': 'Chinois traditionnel',
}

export default LanguageListFR